import userAgentParser from 'ua-parser-js';

import { type Device, AppVersion } from '../types';

let queryParameters: { [key: string]: string | undefined; } = {};
try {
  queryParameters = Object.fromEntries(new URLSearchParams(window.location.search).entries());
} catch {
  // Ignore
}

// navigator does not exist in node-based execution environments
function parseUserAgentDesktop(userAgent: string) {
  const userAgentParts = userAgent.split(' ');
  let systemName = userAgentParts[1];
  if (systemName === 'macos') {
    systemName = 'Mac OS';
  } else if (systemName === 'windows') {
    systemName = 'Windows';
  }

  const systemVersion = userAgentParts[2];
  const appVersion: AppVersion = userAgentParts[0].split('/')[1];

  return {
    name: systemName ?? 'Unknown',
    version: systemVersion ?? 'Unknown',
    appVersion,
    device: { model: 'unknown', type: 'unknown', vendor: 'unknown' },
  };
}

let userAgentInfo = { name: 'Unknown', version: 'Unknown', appVersion: 'unknown', device: { model: 'unknown', type: 'unknown', vendor: 'unknown' } };


if (typeof navigator !== 'undefined') {
  if (navigator.userAgent.startsWith('ReaderDesktop')) {
    userAgentInfo = parseUserAgentDesktop(navigator.userAgent);
  } else {
    const parsedUserAgent = userAgentParser(navigator.userAgent) ?? {
      os: {
        name: 'Unknown',
        version: 'Unknown',
        appVersion: 'unknown',
      },
    };
    const osInfo = parsedUserAgent.os;
    userAgentInfo.name = osInfo.name?.toString() ?? 'Unknown';
    userAgentInfo.version = osInfo.version?.toString() ?? 'Unknown';
  }
}

export const systemName = userAgentInfo.name;
export const systemVersion = userAgentInfo.version;
export const appVersion: AppVersion = userAgentInfo.appVersion;

export const initialQueryParameters = queryParameters;

export const logLevelPreference = initialQueryParameters.__logLevel || process.env.READER_LOG_LEVEL;

export const pdftronAssetsDirectoryName = process.env.VITE_PDFTRON_ASSETS_DIRECTORY_NAME;

export const isBoox = false;

// Force the in-memory RxDB storage to run locally i.e. not in a Shared Worker
// NOTE: Since all queries are run in the UI thread, an excessive DB load might freeze up the app.
// DO NOT EXTRAPOLATE and assume this is the case in production as well. In production, the DB runs in a separate thread.
export const shouldRunRxDBInMemoryStorageLocally = Boolean(
  process.env.SHOULD_RUN_RXDB_IN_MEMORY_STORAGE_LOCALLY,
);

export const shouldPrintSqlQueryPlans = false; // N/A for web

export const isBookwise = false;
export const isNewRelicEnabled = false;

export const device: Device = {
  model: userAgentInfo.device.model || 'unknown',
  type: userAgentInfo.device.type || 'unknown',
  vendor: userAgentInfo.device.vendor || 'unknown',
};

export const isTablet = false;
export const isLargeTablet = false;
export const getInitialDimensions = () => typeof window !== 'undefined'
  ? { width: window.innerWidth, height: window.innerHeight, fontScale: 1, scale: 1 }
  : { width: 0, height: 0, fontScale: 1, scale: 1 };

export const getAreAudiobooksEnabled = (): boolean => {
  return isBookwise;
};

export const mobileReaderChatWebsocketsHost = undefined;

export const shouldEnableScrollsToTop = false;
